
// /**
//  * 会員限定処理
//  */
// !(function (ns) {
//   /**
//    * urlの文字列からドメインを取得
//    * @param {string} url
//    * @return {string}
//    */
//   function getDomain(url) {
//     let domain;
//     if (!url) {
//       return '';
//     }
//     if (url.indexOf('://') > -1) {
//       domain = url.split('/')[2];
//     } else {
//       domain = url.split('/')[0];
//     }
//     domain = domain.split(':')[0];
//     domain = domain.split('?')[0];
//     return domain;
//   }

//   /**
//    * memberonlyオブジェクト
//    */
//   const mo = {};

//   /**
//    * リファラーを確認して会員限定かどうかを確認する
//    *
//    * 特定のリファラー経由の場合trueになり、localStorageにデータを保存する
//    * localStorageに保存されたデータは7日間有効
//    *
//    * localStorageにデータがなかったり、リファラーが違う場合はfalseになる
//    *
//    * @param {Array<string>} referrerUrlList
//    * @return {Boolean}
//    */
//   mo.isMemberReferrer = function (referrerUrlList) {
//     if (!referrerUrlList || referrerUrlList.length == 0) {
//       return false;
//     }

//     const storageUrlKey = 'referrerUrl';
//     const storageDateKey = 'referrerDate';
//     // const expiration = 7;
//     const expiration = 1;

//     // 対象となるドメインを取り出す
//     const referrerDomain = getDomain(document.referrer);
//     const storageDomain = getDomain(localStorage.getItem(storageUrlKey));

//     // ドメインリストを作成
//     const validateDomainList = referrerUrlList.map(function (url) { return getDomain(url) });

//     // リファラーが認証ページ経由の場合はstorageを更新してtrue
//     const isValidDomain = validateDomainList.some(function (domain) { return referrerDomain === domain });
//     if (isValidDomain) {
//       const now = new Date();
//       now.toISOString();
//       localStorage.setItem(storageUrlKey, referrerDomain);
//       localStorage.setItem(storageDateKey, now.toISOString());
//       return true;
//     }

//     // ストレージに保存されているリファラーURLが対象のドメインに一致しているかどうか
//     const isValidStorageDomain = validateDomainList.some(function (domain) { return storageDomain === domain });
//     if (isValidStorageDomain) {
//       const storageDateValue = localStorage.getItem(storageDateKey);
//       if (storageDateValue) {
//         // 日付が保存されている場合
//         const targetDate = new Date(storageDateValue);
//         const baseDate = new Date();
//         baseDate.setDate(baseDate.getDate() - expiration);
//         if (targetDate >= baseDate) {
//           // 日付が有効ならtrue
//           return true;
//         } else {
//           // 無効なら削除してfalse
//           localStorage.removeItem(storageUrlKey);
//           localStorage.removeItem(storageDateKey);
//           return false;
//         }
//       } else {
//         return false;
//       }
//     }

//     return false;
//   }

//   // 有効期限までの残り時間を表示する関数
//   mo.showRemainingHours = function () {
//     const storageDateKey = 'referrerDate';
//     // const expirationHours = 7 * 24; // 7日 = 168時間
//     const expirationHours = 1 * 24; // 1日 = 24時間

//     const storageDateValue = localStorage.getItem(storageDateKey);
//     if (storageDateValue) {
//       const storedDate = new Date(storageDateValue);
//       const now = new Date();

//       const diffMs = now - storedDate;
//       const diffHours = diffMs / (1000 * 60 * 60);
//       const remainingHours = Math.max(0, expirationHours - diffHours);

//       console.log(`会員限定の有効期限はあと約 ${remainingHours.toFixed(1)} 時間です`);
//     } else {
//       console.log('会員限定データは保存されていません');
//     }
//   };

//   ns.mo = mo;
// })(window);


/**
 * 会員限定処理（テスト用：有効期限 3分）
 */
!(function (ns) {
  /**
   * urlの文字列からドメインを取得
   * @param {string} url
   * @return {string}
   */
  function getDomain(url) {
    let domain;
    if (!url) return '';
    if (url.indexOf('://') > -1) {
      domain = url.split('/')[2];
    } else {
      domain = url.split('/')[0];
    }
    domain = domain.split(':')[0];
    domain = domain.split('?')[0];
    return domain;
  }

  // === ここを3分にする（本番では 7日 に戻す） ===
  const EXPIRATION_MINUTES = 1440;

  /**
   * memberonlyオブジェクト
   */
  const mo = {};

  /**
 * リファラーを確認して会員限定かどうかを確認する（リロードでは延命しない版）
 * @param {Array<string>} referrerUrlList
 * @return {Boolean}
 */
mo.isMemberReferrer = function (referrerUrlList) {
  if (!referrerUrlList || referrerUrlList.length === 0) {
    return false;
  }

  const storageUrlKey = 'referrerUrl';
  const storageDateKey = 'referrerDate';

  // ---- 追加: リロード/同一オリジンの判定（延命させないガード）----
  function getDomain(url) {
    let domain;
    if (!url) return '';
    if (url.indexOf('://') > -1) domain = url.split('/')[2];
    else domain = url.split('/')[0];
    domain = domain.split(':')[0];
    domain = domain.split('?')[0];
    return domain;
  }
  function getNavType() {
    try {
      const n = (performance && performance.getEntriesByType)
        ? performance.getEntriesByType('navigation')[0]
        : null;
      if (n && n.type) return n.type; // 'navigate'|'reload'|'back_forward'|'prerender'
      if (performance && performance.navigation) {
        return performance.navigation.type === 1 ? 'reload'
             : performance.navigation.type === 2 ? 'back_forward'
             : 'navigate';
      }
    } catch (e) {}
    return 'navigate';
  }
  const isReloadLike = (function(){
    const t = getNavType();
    return t === 'reload' || t === 'back_forward';
  })();
  const isSameOriginRef = (function(){
    try { return getDomain(document.referrer) === location.hostname; } catch(e){ return false; }
  })();
  const blockReissueNow = isReloadLike || isSameOriginRef;
  // -----------------------------------------------------------

  // 対象となるドメインを取り出す
  const referrerDomain = getDomain(document.referrer);
  const storageDomain  = getDomain(localStorage.getItem(storageUrlKey));

  // ドメインリストを作成
  const validateDomainList = referrerUrlList.map(function (url) { return getDomain(url); });

  // リファラーが認証ページ経由の場合は true
  const isValidDomain = validateDomainList.some(function (domain) { return referrerDomain === domain; });
  if (isValidDomain) {
    // ★ここが肝: リロード/同一オリジン遷移では「保存日時を更新しない」
    if (!blockReissueNow) {
      const now = new Date().toISOString();
      localStorage.setItem(storageUrlKey, referrerDomain);
      localStorage.setItem(storageDateKey, now);
    }
    return true;
  }

  // ストレージに保存されているリファラーURLが対象のドメインに一致しているかどうか
  const isValidStorageDomain = validateDomainList.some(function (domain) { return storageDomain === domain; });
  if (isValidStorageDomain) {
    const storageDateValue = localStorage.getItem(storageDateKey);
    if (!storageDateValue) return false;

    // ここはあなたの運用値に合わせて（3分テストなら 3 にする）
    const EXPIRATION_MINUTES = 1440; // ← 1分テスト。7日運用時は 7*24*60 に変更
    const targetDate = new Date(storageDateValue);
    const baseDate = new Date();
    baseDate.setMinutes(baseDate.getMinutes() - EXPIRATION_MINUTES);

    if (targetDate >= baseDate) {
      return true;             // 有効
    } else {
      // 期限切れなら削除
      localStorage.removeItem(storageUrlKey);
      localStorage.removeItem(storageDateKey);
      return false;
    }
  }

  return false;
};

  // 有効期限までの残り時間を表示する関数（3分基準）
  mo.showRemainingHours = function () {
    const storageDateKey = 'referrerDate';
    const storageDateValue = localStorage.getItem(storageDateKey);

    if (storageDateValue) {
      const storedDate = new Date(storageDateValue);
      const now = new Date();

      const diffMs = now - storedDate; // 経過ミリ秒
      const expirationMs = EXPIRATION_MINUTES * 60 * 1000;
      const remainingMs = Math.max(0, expirationMs - diffMs);

      const remainingMin = remainingMs / (60 * 1000);
      const remainingSec = Math.floor((remainingMs % (60 * 1000)) / 1000);

      console.log(
        `会員限定の有効期限はあと約 ${remainingMin.toFixed(1)} 分（${Math.floor(remainingMin)}分${remainingSec}秒）です`
      );
    } else {
      console.log('会員限定データは保存されていません');
    }
  };

  // （テスト時便利）手動でクリアしたい場合に使えます
  mo.clearMemberReferrer = function () {
    localStorage.removeItem('referrerUrl');
    localStorage.removeItem('referrerDate');
    console.log('会員限定データをクリアしました');
  };

  ns.mo = mo;
})(window);

/**
   * 残りミリ秒を返す（3分設定に追従）
   * 0 のとき失効済み
   */
  mo.getRemainingMs = function () {
    try {
      var storageDateKey = 'referrerDate';
      var val = localStorage.getItem(storageDateKey);
      if (!val) return 0;
      var stored = new Date(val);
      var now = new Date();
      var diffMs = now - stored; // 経過
      var expirationMs = (typeof EXPIRATION_MINUTES !== 'undefined' ? EXPIRATION_MINUTES : 3) * 60 * 1000;
      var remain = expirationMs - diffMs;
      return remain > 0 ? remain : 0;
    } catch (e) {
      return 0;
    }
  };

  /**
   * 便利：有効期限(分)を返す（UIで文言に使いたい場合）
   */
  mo.getExpirationMinutes = function () {
    return (typeof EXPIRATION_MINUTES !== 'undefined' ? EXPIRATION_MINUTES : 3);
  };